export default "__VITE_ASSET__5565a2f5__"